export default "__VITE_ASSET__BWuHwSH___"